export default {
    apiKey: "AIzaSyCgYNo4KhfNIaGH857nj5RhnkguEgaP4Y8",
    authDomain: "pallet-pooling.firebaseapp.com",
    projectId: "pallet-pooling",
    storageBucket: "pallet-pooling.appspot.com",
    messagingSenderId: "869704185814",
    appId: "1:869704185814:web:942e7ffaf5f86f5a835677",
    measurementId: "G-SRVP397MT6"
};
